import { createClient } from '@supabase/supabase-js'

const url = (import.meta.env.VITE_SUPABASE_URL ?? '').trim()
const anonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY ?? '').trim()

// Lazy-load Supabase to avoid blocking initial page load
let supabaseInstance: ReturnType<typeof createClient> | null = null

export function getSupabase() {
  if (!supabaseInstance) {
    supabaseInstance = createClient(
      url || 'https://placeholder.supabase.co',
      anonKey || 'placeholder-anon-key',
      {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          flowType: 'pkce',
        },
      }
    )
  }
  return supabaseInstance
}

// For backward compatibility
export const supabase = new Proxy({} as any, {
  get: (_target, prop) => {
    return getSupabase()[prop as keyof typeof supabaseInstance]
  },
})

export function isSupabaseBrowserConfigured(): boolean {
  return Boolean(url && anonKey)
}
